<template>
  <div>
    <div class="banner88">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082807390745.jpg"></el-image>
      <div class="cover">
        <h1>品牌系列</h1>
        <div class="subtitle">健康手套</div>
      </div>
    </div>
    <div class="content">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane :label="item.name" :name="item.categoryNo" v-for="(item,index) in productCategories" :key="index">
          <div class="tab-content">
            <div class="img">
              <el-image :src="item.coverUrl"></el-image>
            </div>
            <div class="title">{{ item.name }}</div>
            <div class="desc">{{ item.description }}</div>
            <div class="list">
              <el-row :gutter="20">
                <el-col :span="8" v-for="(item2,index2) in getList(item)" :key="index2">
                  <router-link :to="{path:'/product-detail',query:{id:item2.id}}">
                    <div class="item">
                      <div class="cover">
                        <el-image :src="item2.coverUrl"></el-image>
                      </div>
                      <div class="name">{{ item2.name }}</div>
                    </div>
                  </router-link>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {getProductInfoIndex} from '@/api/api'

export default {
  name: "Index",
  data() {
    return {
      activeName: "first",
      productCategories: null,
      productInfos: null,
    }
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getProductInfoIndex().then((res) => {
        this.productCategories = res.data.productCategories;
        this.activeName = this.productCategories[0].categoryNo;
        this.productInfos = res.data.productInfos;
      });
    },
    getList(t) {
      let data = [];
      for (let i = 0; i < this.productInfos.length; i++) {
        let item = this.productInfos[i];
        if (t.categoryNo == item.categoryNo) {
          data.push(item);
        }
      }
      return data;
    }
  }
}
</script>

<style scoped>
@import url("Index.css?v=100");
</style>